<!-- 赛事预览详情 -->
<template>
    <div>
        <Breadcrumb :title="title" v-if="show" class="bread"/>
        <div class="detail-wrap" v-if="ready">                
            <el-row >
                <el-col class="pub-title">{{ list.title }} </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="list.sponsor">
                <el-col>
                    <div class="sub-title">冠名单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.sponsor }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="list.guidance">
                <el-col>
                    <div class="sub-title">指导单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.guidance }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="hostData">
                <el-col>
                    <div class="sub-title">主办单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ hostData }}</div>
                </el-col>
            </el-row>
           
            <el-row class="mg-t-20" v-if="underTakeData">
                <el-col>
                    <div class="sub-title">承办单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ underTakeData }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="sponsorData">
                <el-col>
                    <div class="sub-title">赞助单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ sponsorData }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="organizerData">
                <el-col>
                    <div class="sub-title">协办单位</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ organizerData }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">报名费用</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.totalFee }} 元</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">赛事积分</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.totalGrade }} 分</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">赛事地点</div></el-col>
                <el-col>
                    <div class="sub-name">{{ list.address }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">参赛人数</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.amount }}人</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">参赛范围</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.faceObject }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">赛事状态</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.status }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="list.round >0">
                <el-col>
                    <div class="sub-title">赛事轮数</div></el-col>
                <el-col>
                    <div class="sub-name">{{ list.round }}轮</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="list.phone">
                <el-col>
                    <div class="sub-title">联系方式</div></el-col>
                <el-col>
                    <div class="sub-name">
                        <a :href="'tel:'+ list.phone"  class="call-number"
                            v-on:click.prevent="makeCall(list.phone)"> {{ list.phone }}</a>
                    </div>
                </el-col>
            </el-row>            
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">赛事日期</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.eventDate }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20" v-if="list.eventType">
                <el-col>
                    <div class="sub-title">赛事类型</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.eventType }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">奖励设置</div>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ list.award }}</div>
                </el-col>
                <el-col v-if="list.imageUrl1">
                    <el-image :src="list.imageUrl1" class="image-url"></el-image>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">赛事流程</div>
                </el-col>
                <el-col class="mg-t-20 wrap-line">{{ list.eventFlow }}</el-col>
                <el-col v-if="list.imageUrl2">
                    <el-image :src="list.imageUrl2" class="image-url"></el-image>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">报名须知</div>                                  
                </el-col>  
                <el-col class="wrap-line">
                    {{ list.notice }}
                </el-col>  
                <el-col v-if="list.imageUrl3">
                    <el-image :src="list.imageUrl3" class="image-url"></el-image>
                </el-col>              
            </el-row>                  
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">竞赛规则</div>                
                </el-col>
                <el-col class="wrap-line">
                    {{ list.rules }}
                </el-col>
                <el-col v-if="list.imageUrl4">
                    <el-image :src="list.imageUrl4" class="image-url"></el-image>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <div class="sub-title">自愿参赛承诺书</div>                                       
                </el-col>
                <el-col class="wrap-line">
                    {{ list.letter }}
                    <div>
                        <br>本人已认真阅读、全面理解以上内容，且对上述所有内容予以确认并承担相应的法律责任，本人签署此责任书系自愿。
                        <br>选手签名:    
                    </div>                   
                </el-col>
            </el-row>            
        </div>
    </div>
</template>
<script>

import Breadcrumb from '@/components/Breadcrumb'
import Qrcode from '@/components/Qrcode'
export default {
    components: {
        Breadcrumb,
        Qrcode
    },
    data() {
        return {
            show: false,
            cats: [],
            ready: false,
            list: {},
            publishId: '',
            clientWidth: '',
            applyUrl: '',
            hostData: '',
            sponsorData: '',
            underTakeData: '',
            organizerData: '',
            publishUrl: window.location.href, 
            url: 'http://www.guanyb.cn/#/publishPreview?id=',
            disabled:false,
            faceGradeList: [],
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.publishId = this.$route.query.id       
        this.ready = true
        if(this.ready){
            this.getHost()
            this.getSponsor()
            this.getUnderTakeData()
            this.getOrganizerData()
        }
        this.getFaceGrade()
    },
    watch:{      
      clientWidth(){             
        if(this.clientWidth > 768){
          this.show = true
        }else{
          this.show = false
        }        
      }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    mounted() {
        this.initData()        
        this.publishUrl =  window.location.origin + '/#/publishPreview?id=' + this.publishId
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.PubPreview,
                i_serial_mark: this.publishId,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{
                        let eventTypeArr =  this.$global.eventTypeList.filter(i=>i.label ===item['类型'])
                        let imageUrl1 = item['奖励设置图片1'] ? this.$help.replaceHttpWithHttps(item['奖励设置图片1']) : '' 
                        let imageUrl2 = item['赛事流程图片1'] ? this.$help.replaceHttpWithHttps(item['赛事流程图片1']) : '' 
                        let imageUrl3 = item['报名须知图片1'] ? this.$help.replaceHttpWithHttps(item['报名须知图片1']) : '' 
                        let imageUrl4 = item['竞赛规则图片1'] ? this.$help.replaceHttpWithHttps(item['竞赛规则图片1']) : '' 
                        let eventDate = item['赛事结束日期'].toString().slice(0, 10)
                        let faceLevel = this.faceGradeList.filter(i=> i.value === item['面向维度级别'])
                        return{
                            title: item['主题'],
                            amount: item['参赛人数'],
                            playerNumber: item['报名人数'],
                            address: item['赛事地点省份'] +''+ item['赛事地点市'] +''+item['赛事地点'],
                            sponsor: item['赞助'],
                            award: item['奖励设置'],
                            eventFlow: item['赛事流程'],
                            notice: item['报名须知'],
                            rules:item['竞赛规则'],
                            letter: item['参赛承诺'],
                            totalFee: item['报名费用'],
                            eventDate: eventDate,
                            eventStartDate: item['赛事开始日期'],
                            eventEndDate: item['赛事结束日期'],
                            type: eventTypeArr[0].value,
                            eventType: item['类型'],
                            guidance: item['指导单位'],
                            totalGrade: item['系统积分'],
                            imageUrl1: imageUrl1,
                            imageUrl2: imageUrl2,
                            imageUrl3: imageUrl3,
                            imageUrl4: imageUrl4,
                            status: item['状态'],
                            round: item['轮数'],
                            phone: item['备注'],
                            faceObject: faceLevel[0].des,
                        }
                    })
                    this.list = { ...list[0]}
                    this.pubType = list[0].type
                    this.disabled = list[0].amount < list[0].playerNumber || list[0].amount === list[0].playerNumber? true: false
                    this.applyUrl = 'http://www.guanyb.cn/#/apply?id='+ this.publishId +'&type='+ this.pubType
                }
            })
        },
        toApplyPath(){
            this.$router.push({
                path: '/apply',
                query: {
                    id: this.publishId,
                    type: this.pubType
                }
            })
        },
        copyApplyLink(url){
            var input = document.createElement("input"); // 创建input对象
            input.value = url; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message.success('复制链接成功：'+ input.value)
        },
        handleResize(){
            this.clientWidth = window.innerWidth || document.body.clientWidth;
        },
        // 查询主办单位
        getHost(){
            let params = {
                opcode:this.$code.HostQuery,
                i_serial_mark: this.publishId
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.hostData = result.map(item => item['主办方']).join('\n')
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        // 查询冠名单位
        getSponsor(){
            let params = {
                opcode:this.$code.SponsorQuery,
                i_serial_mark: this.publishId
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.sponsorData = result.map(item => item['冠名方']).join(`\n`)

                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        // 查询承办
        getUnderTakeData(){
            let params = {
                opcode:this.$code.UnderTakeQuery,
                i_serial_mark: this.publishId
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.underTakeData = result.map(item =>item['承办方']).join('\n')
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        // 查询协办
        getOrganizerData(){
            let params = {
                opcode:this.$code.OrganizerQuery,
                i_serial_mark: this.publishId
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.organizerData= result.map(item =>item['协办方']).join('\n')
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        makeCall(number){
            window.location.href = `tel:${number}`;
        },
        // 获取赛事评定维度  面向维度
        getFaceGrade(){
            let params = {
                opcode: this.$code.PubGradeCode,
                i_no: 3,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.faceGradeList = result.map(item=>{
                        return{
                            grade: item['对应积分'],
                            des: item['说明'],
                            value: item['级别'],
                            label: item['评定类型']
                        }
                    })
                }
            })
        },
    },
    destroyed(){
      window.removeEventListener('resize', this.handleResize);
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.pub-title{
    font-size: 20px;
    padding-bottom: 20px;
    text-align: center;
}
.sub-title{
    width: 120px;   
    padding: 5px 10px;
    font-size: 16px;
    color: #fff;
    background-color: #e62e02;
    border-radius: 5px;
    text-align: center;
}
.sub-name{
    padding: 15px;
    font-size: 16px;
    white-space: pre-line;
}
.mg-l-20{
    margin-left: 20px;
}
.wrap-line{
    white-space: pre-line;
    font-size: 16px
}
.qrcode{
    display: flex;
    margin-top: 15px;
}
@media screen and (min-width: 769px){
  .bread{
    margin: 30px 0 0 215px;
  }
  .detail-wrap{   
    width: 750px;
    font-size: 16px;
  }
  .wrap-line{
    line-height: 20px;
  }
  .dialog-login >>> .el-dialog{
        width: 30%
    }
}
@media screen and (max-width:768px){
  .detail-wrap{
    width: 80vw;
    // margin-top: 0;
    padding: 0px;
    border: 0;
  }
  .sub-name{
    line-height: 20px;
    text-align: center;
  }
  .wrap-line{
    line-height: 20px;
  }
  .sub-title{
    margin: 0 auto;
    width: 120px;
    padding: 5px;
    text-align: center;
  }
}
.image-url{
    width: 60%;
}
.call-number{
    text-decoration: underline;
    color: #e62e02
}
</style>


// WEBPACK FOOTER //
// src/views/publish/publishPreview.vue